type HTMLElementOrDocument = HTMLElement | Document;

const slottedStyleTagId = 'dc-ui-slotted-styles';

export const getNodeToPrependTo = (
  rootNode: HTMLElementOrDocument,
): HTMLElement => {
  return rootNode === document ? rootNode.head : (rootNode as HTMLElement);
};

/**
 * Adds an inheritable style for slotted content.
 * @param host
 * @param slottedStyles
 * @returns void
 */
export const attachSlottedCss = (
  host: HTMLElement,
  slottedStyles: string,
): void => {
  const css = slottedStyles;
  const rootNode = host.getRootNode() as HTMLElementOrDocument;

  if (!rootNode.isConnected) {
    return;
  }

  // Use host-specific ID to allow multiple components to have their own styles
  const styleId = `${slottedStyleTagId}-${host.getAttribute('data-uuid')}`;
  let style = host.querySelector(`#${styleId}`);

  if (!style) {
    style = document.createElement('style');
    style.id = styleId;
    host.insertBefore(style, host.firstChild);
  }

  style.appendChild(document.createTextNode(css));
  style.normalize(); // merge text nodes
};
